/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetWebsitImageConfigSortListRespVo
 */
export interface GetWebsitImageConfigSortListRespVo {
    /**
     * 图片数据编号
     * @type {number}
     * @memberof GetWebsitImageConfigSortListRespVo
     */
    id?: number;
    /**
     * 图片名称
     * @type {string}
     * @memberof GetWebsitImageConfigSortListRespVo
     */
    name?: string;
    /**
     * 图片排序
     * @type {number}
     * @memberof GetWebsitImageConfigSortListRespVo
     */
    sort?: number;
}

/**
 * Check if a given object implements the GetWebsitImageConfigSortListRespVo interface.
 */
export function instanceOfGetWebsitImageConfigSortListRespVo(value: object): value is GetWebsitImageConfigSortListRespVo {
    return true;
}

export function GetWebsitImageConfigSortListRespVoFromJSON(json: any): GetWebsitImageConfigSortListRespVo {
    return GetWebsitImageConfigSortListRespVoFromJSONTyped(json, false);
}

export function GetWebsitImageConfigSortListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetWebsitImageConfigSortListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'sort': json['sort'] == null ? undefined : json['sort'],
    };
}

export function GetWebsitImageConfigSortListRespVoToJSON(json: any): GetWebsitImageConfigSortListRespVo {
    return GetWebsitImageConfigSortListRespVoToJSONTyped(json, false);
}

export function GetWebsitImageConfigSortListRespVoToJSONTyped(value?: GetWebsitImageConfigSortListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'sort': value['sort'],
    };
}

